import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { randomNumber } from '../../../catalog/Others';
import { isValidObject, isValidString } from '../../../catalog/Validity';
import { getHTMLTextFromNormalText } from '../../../catalog/Website';
import { context } from '../../../globalState/GlobalState';
import BreadCrumbs1 from '../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import Title1 from '../../uiElements/title/title1/Title1';
import './css/About1.css';
import Spinner1 from '../../uiElements/spinners/spinner1/Spinner1';
import { websiteStyles } from '../../../catalog/TeamInfo';
import StaffsComponent1 from '../../uiElements/staffsComponents/staffsComponent1/StaffsComponent1';

const About1 = (props) => {
    const { staffs, loadingSpinner } = props;
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
        ];
    };

    return (
        <>
            <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb="About" marginLeft="100px" />
            <div className="about1-container box-shadow-black curve-border-20px x-center p-t-20px p-b-100px p-l-100px p-r-100px m-t-50px">
                <Title1 title="About" />
                {globalState.stylesDownloaded ? (
                    <>
                        <p className="font-size-3xl font-spacing-wide full-width text-left-align m-t-50px m-b-50px font-weight-800">{globalState.teamAlias}</p>
                        {/* <p className="font-size-3xl font-spacing-wide full-width text-left-align m-t-50px m-b-50px font-weight-800">{`${globalState.teamName} - ${globalState.organizationName}`}</p> */}
                        {isValidObject(globalState.teamInfo) && isValidString(globalState.teamInfo.longAbout) ? (
                            <div className="about1-content font-size-xl alegreya-font-family font-spacing-wider line-height-wider text-left-align full-width">
                                {parse(getHTMLTextFromNormalText(globalState.teamInfo.longAbout))}
                            </div>
                        ) : null}
                        <div className="about1-contact full-width m-t-50px">
                            {isValidObject(globalState.teamInfo) && isValidObject(globalState.teamInfo.contacts) ? (
                                <div className="about1-contact-part m-b-50px">
                                    <p className="font-size-2xl text-uppercase m-t-0 m-b-20px text-left-align">Contact Information</p>
                                    {globalState.teamInfo.contacts.map((contact) => {
                                        return (
                                            <React.Fragment key={randomNumber()}>
                                                {/* <p className="font-size-xl text-uppercase m-t-30px m-b-10px text-left-align">{contact.title}</p> */}
                                                {isValidString(contact.email) ? (
                                                    <div className="about1-contact-text curve-border-10px m-t-5px m-b-5px">
                                                        <a className="font-size-l alegreya-font-family font-spacing-wider line-height-wider text-center-align text-white text-no-underline" href={`mailto:${contact.email}`}>{contact.email}</a>
                                                    </div>
                                                ) : null}
                                                {isValidString(contact.tel) ? (
                                                    <div className="about1-contact-text curve-border-10px m-t-5px m-b-5px">
                                                        <a className="font-size-l alegreya-font-family font-spacing-wider line-height-wider text-center-align text-white text-no-underline" href={`tel:${contact.tel}`}>{contact.tel}</a>
                                                    </div>
                                                ) : null}
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            ) : null}
                            {isValidObject(globalState.teamInfo) && isValidObject(globalState.teamInfo.address) ? (
                                <div className="about1-contact-part m-b-0">
                                    <p className="font-size-2xl text-uppercase m-t-0 m-b-20px text-left-align">Address</p>
                                    <div>
                                        <p className="about1-contact-text font-size-l alegreya-font-family font-spacing-wider line-height-wider m-t-5px m-b-5px text-center-align curve-border-10px">{globalState.teamInfo.address}</p>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                            <img src={globalState.logo.logo2} className="about1-icon m-t-0 m-b-0 x-center" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                        ) : null}
                    </>
                ) : <Spinner1 color={websiteStyles.primaryColor} marginTop={50} />}
            </div>
            {staffs.length > 0 ? <StaffsComponent1 staffs={staffs} loadingSpinner={loadingSpinner} /> : null}
        </>
    );
};

About1.propTypes = {
    staffs: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(About1);
